import React, { useEffect, useState } from "react";
import { Table, Tag, Button, Modal, Form, Input, Select, message } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { getOrders, updateAOrder } from "../features/auth/authSlice";
import { BiEdit } from "react-icons/bi";
import { Link } from "react-router-dom";

const { Option } = Select;

const ProcessPreorder = () => {
  const dispatch = useDispatch();
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [form] = Form.useForm();

  useEffect(() => {
    dispatch(getOrders());
  }, [dispatch]);

  const orderState = useSelector((state) => state?.auth?.orders.orders);

  // Filter preorder orders
  const preorderOrders = orderState?.filter(order => order?.orderStatus === "Preorder") || [];

  const columns = [
    {
      title: "SNo",
      dataIndex: "key",
    },
    {
      title: "Customer",
      dataIndex: "customer",
    },
    {
      title: "Order ID",
      dataIndex: "orderId",
    },
    {
      title: "Amount",
      dataIndex: "amount",
    },
    {
      title: "Date",
      dataIndex: "date",
    },
    {
      title: "Items",
      dataIndex: "items",
    },
    {
      title: "Action",
      dataIndex: "action",
    },
  ];

  const data = [];
  for (let i = 0; i < preorderOrders?.length; i++) {
    data.push({
      key: i + 1,
      customer: preorderOrders[i]?.user?.firstname + " " + preorderOrders[i]?.user?.lastname,
      orderId: preorderOrders[i]?.customOrderId || `#${preorderOrders[i]?._id?.slice(-8).toUpperCase()}`,
      amount: `₹${preorderOrders[i]?.totalPrice?.toLocaleString()}`,
      date: new Date(preorderOrders[i]?.createdAt).toLocaleDateString(),
      items: preorderOrders[i]?.orderItems?.length,
      action: (
        <Button 
          type="primary" 
          onClick={() => {
            setSelectedOrder(preorderOrders[i]);
            setIsModalVisible(true);
          }}
        >
          Process Payment
        </Button>
      ),
    });
  }

  const handleProcessPayment = (values) => {
    // Update order status to "Ordered" and process payment
    dispatch(updateAOrder({ 
      id: selectedOrder._id, 
      status: "Ordered" 
    })).then(() => {
      message.success("Preorder payment processed successfully!");
      setIsModalVisible(false);
      form.resetFields();
      // Refresh orders
      dispatch(getOrders());
    });
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    form.resetFields();
  };

  return (
    <div>
      <h3 className="mb-4 title">Process Preorder Payments</h3>
      
      {preorderOrders?.length === 0 ? (
        <div className="alert alert-info">
          <p>No preorder orders found.</p>
        </div>
      ) : (
        <div>
          <Table columns={columns} dataSource={data} />
          
          <Modal
            title="Process Preorder Payment"
            visible={isModalVisible}
            onCancel={handleCancel}
            footer={null}
          >
            {selectedOrder && (
              <div className="mb-4">
                <h5>Order Details</h5>
                <p><strong>Customer:</strong> {selectedOrder?.user?.firstname} {selectedOrder?.user?.lastname}</p>
                <p><strong>Order ID:</strong> {selectedOrder?.customOrderId || `#${selectedOrder?._id?.slice(-8).toUpperCase()}`}</p>
                <p><strong>Total Amount:</strong> ₹{selectedOrder?.totalPrice?.toLocaleString()}</p>
                <p><strong>Items:</strong> {selectedOrder?.orderItems?.length}</p>
              </div>
            )}
            
            <Form
              form={form}
              layout="vertical"
              onFinish={handleProcessPayment}
            >
              <Form.Item
                name="paymentMethod"
                label="Payment Method"
                rules={[{ required: true, message: 'Please select a payment method' }]}
              >
                <Select placeholder="Select payment method">
                  <Option value="razorpay">Razorpay</Option>
                  <Option value="cod">Cash on Delivery</Option>
                  <Option value="bank_transfer">Bank Transfer</Option>
                </Select>
              </Form.Item>
              
              <Form.Item
                name="transactionId"
                label="Transaction ID (Optional)"
              >
                <Input placeholder="Enter transaction ID" />
              </Form.Item>
              
              <Form.Item>
                <Button type="primary" htmlType="submit" block>
                  Process Payment
                </Button>
              </Form.Item>
            </Form>
          </Modal>
        </div>
      )}
    </div>
  );
};

export default ProcessPreorder;